(() => {
  const specs = {relay:{id:16581257593100,plan:739239723276},home:{id:16581257691404,plan:739239756044}};
  const key = 'decouverte-delivery-pilot';
  const planId = item => item.selling_plan_allocation?.selling_plan?.id;
  const identity = item => JSON.stringify([item.variant_id,planId(item)||null,Object.entries(item.properties||{}).sort(([a],[b])=>a.localeCompare(b))]);
  const sameLine = (a,b) => identity(a)===identity(b);
  const managedItems = cart => cart.items.filter(item=>Object.values(specs).some(s=>s.id===item.product_id)&&item.properties?._anom_funnel_key===key);
  const matches = (item,variant,plan) => item.variant_id===variant&&planId(item)===plan&&item.quantity>0;
  function select(config,mode,size,grind,roast,cents) {
    const spec=specs[mode], product=config?.products?.[mode];
    if(!spec||product?.id!==spec.id||product.planId!==spec.plan)return null;
    const variant=product.variants.find(v=>v.size===size&&v.grind===grind&&v.roast===roast);
    if(!variant?.available||variant.price!==cents||!variant.plans.some(p=>p.id===spec.plan&&p.price===Math.round(cents*.5)))return null;
    return {...variant,productId:spec.id,sellingPlan:spec.plan};
  }
  function verifyAdded(before,after,variant,plan,price,quantity=1) {
    if(!Array.isArray(before.items)||!Array.isArray(after.items))return false;
    const added=after.items.filter(item=>matches(item,variant,plan)&&item.properties?._anom_funnel_key===key);
    const firstPrice=Math.round(price*.5);
    return added.length===1&&added[0].quantity===quantity&&added[0].original_price===firstPrice&&added[0].selling_plan_allocation?.price===firstPrice&&before.items.every(old=>after.items.some(item=>sameLine(item,old)&&item.quantity===old.quantity));
  }
  async function request(path,body) {
    const response=await fetch(path,body?{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}:{cache:'no-store'});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||'Le panier ne peut pas être vérifié. Veuillez réessayer.');
    return result;
  }
  async function add(variant,properties) {
    if(!Object.values(specs).some(s=>s.id===variant.productId&&s.plan===variant.sellingPlan))throw new Error('Plan de livraison non vérifié.');
    const before=await request('/cart.js');
    const managed=managedItems(before);
    if(managed.length>1)throw new Error('Plusieurs sélections Découverte sont présentes. Vérifiez votre panier avant de continuer.');
    const previous=managed[0], quantity=previous?.quantity||1;
    if(previous&&matches(previous,variant.id,variant.sellingPlan))return;
    await request('/cart/add.js',{items:[{id:variant.id,quantity,selling_plan:variant.sellingPlan,properties:{...properties,_anom_funnel_key:key}}]});
    const after=await request('/cart.js');
    if(!verifyAdded(before,after,variant.id,variant.sellingPlan,variant.price,quantity))throw new Error('Votre panier doit être vérifié avant de payer. Merci de nous contacter.');
    if(previous){
      const old=after.items.find(item=>sameLine(item,previous));
      if(!old)throw new Error('Votre ancienne sélection doit être vérifiée dans le panier.');
      const changed=await request('/cart/change.js',{id:old.key,quantity:0});
      if(!verifyAdded({items:before.items.filter(item=>item!==previous)},changed,variant.id,variant.sellingPlan,variant.price,quantity))throw new Error('Votre panier doit être vérifié avant de payer.');
    }
  }
  window.AnomDiscoveryCart=Object.freeze({select,managedItems,matches,sameLine,verifyAdded,add});
})();
